import defaultLayoutComponent from '~pages/nrw/layouts/NrwDefaultLayoutComponents.js'
// import nrwSingleLayoutComponents from '~pages/nrw/layouts/NrwSingleLayoutComponents.js'

let routeInfo = [
  {
    path: 'eduCal/eduPlan',
    name: 'EduPlan',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_eduplan" */'~pages/nrw/educal/eduPlan.vue') }
    ),
    meta: {
      authorized: false
    }
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/nrw/child/eudCalRouter.js